export default "__VITE_ASSET__1ie7wj_$__"